import { headerHeight } from "./DartsScoring.const"
import * as _state from "./DartsScoring.state";
import * as _types from "./DartsScoring.types";
import { RequestStatus } from "../../../common/enums/RequestStatus.enum";
import { DartsGameStatus } from "../../../common/types/DartsGameStatuses";
import IDartsGameIdType from "../../../common/interfaces/IDartsGameIdType";

export function boardHeight(width: number, height: number): number {
    let k = 0.9;
    return Math.min(width, height - headerHeight) * k;
}

export const applyDartsGameScoring = (state: _state.DartsScoringState, data: _types.IDartsGameScoring): void => {
    state.game.legs = data.legs;
    state.game.turnScores = data.turnScores;
    state.game.timeline = [...state.game.timeline, ...data.timeline]
    state.game.lastTurns = data.lastTurns;
    state.game.status = data.status;
    state.playerId = data.playerId;
    state.playerIndex = data.playerIndex;
};

export const applyDartsGameScoringInit = (state: _state.DartsScoringState, data: _types.IDartsGameScoringInit, arg: IDartsGameIdType): void => {
    let game: _state.DartsGameState = {
        gameId: arg.gameId,
        gameType: arg.gameType,
        gameName: data.gameName,
        players: data.players,
        status: data.status,
        legs: data.legs,
        turnScores: data.turnScores,
        timeline: data.timeline,
        lastTurns: data.lastTurns
    }
    state.game = game;
    state.playerId = data.playerId;
    state.playerIndex = data.playerIndex;
};

export const setUI = (state: _state.DartsScoringState, requestStatus: RequestStatus): void => {
    //if (state.game.status !== DartsGameStatus.Running && state.game.status !== DartsGameStatus.PreEnd) {
    //    state.btnUndoDisabled = true;
    //    state.isThrowAllowed = false;
    //    return;
    //}
    switch (requestStatus) {
        case RequestStatus.pending:
            state.btnUndoDisabled = true;
            state.isThrowAllowed = false;
            break;
        case RequestStatus.rejected:
            state.btnUndoDisabled = false;
            state.isThrowAllowed = true;
            break;
        case RequestStatus.fulfilled:
        default:
            if (state.game.timeline.length > 1) {
                state.btnUndoDisabled = false;
            }
            state.isThrowAllowed = true;
            break;
    }
};
